import ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';

const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const exportToCSV = async (csvData: any[], fileName: string) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('data');

  if (csvData.length > 0) {
    const keys = Object.keys(csvData[0]);
    worksheet.columns = keys.map((key) => ({ header: key, key }));
    worksheet.addRows(csvData);
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: XLSX_MIME });
  FileSaver.saveAs(blob, `${fileName}.xlsx`);
};

export const csvToXlsx = async (csvString: string, fileName: string) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('data');

  const lines = csvString.split('\n').filter((line) => line.trim() !== '');
  if (lines.length === 0) {
    return;
  }

  const headers = lines[0].split(',').map((h) => h.trim());
  worksheet.columns = headers.map((header) => ({ header, key: header }));

  const valorNfIndex = headers.indexOf('VALOR_NF');

  for (let i = 1; i < lines.length; i++) {
    const values = lines[i].split(',').map((v) => v.trim());
    const row: Record<string, any> = {};
    headers.forEach((header, idx) => {
      const value = values[idx] ?? '';
      if (idx === valorNfIndex && value !== '') {
        const num = Number(value);
        row[header] = isNaN(num) ? value : num;
      } else {
        row[header] = value;
      }
    });
    worksheet.addRow(row);
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: XLSX_MIME });
  FileSaver.saveAs(blob, fileName);
};
